import { render, staticRenderFns } from "./MetricTabs.vue?vue&type=template&id=63b7721e&scoped=true"
import script from "./MetricTabs.vue?vue&type=script&lang=ts"
export * from "./MetricTabs.vue?vue&type=script&lang=ts"
import style0 from "./MetricTabs.vue?vue&type=style&index=0&id=63b7721e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b7721e",
  null
  
)

export default component.exports